import React from "react";
import {
  setTrackingConsent,
  loadGoogleAnalytics,
} from "../helpers/TrackingConsent";

interface CookieConsentBannerProps {
  onConsent: () => void;
}

const CookieConsentBanner = ({ onConsent }: CookieConsentBannerProps) => {
  const handleAccept = () => {
    setTrackingConsent("accepted");
    loadGoogleAnalytics();
    onConsent();
  };

  const handleDecline = () => {
    setTrackingConsent("declined");
    onConsent();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 border-t border-gray-700 px-4 py-4 sm:px-6">
      <div className="mx-auto max-w-7xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-sm text-gray-300">
          We use cookies for analytics to understand how people use 10GOATS and
          improve the experience.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-1.5 text-sm font-semibold text-gray-300 border border-gray-600 rounded-md hover:bg-gray-800 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-1.5 text-sm font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-500 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
